import { mergeStyles, Stack } from "@fluentui/react";

export interface IRowProps {
    styles?: string;
}

export const Row: React.FC<IRowProps> = (props) => {

    const gridStyles = mergeStyles([{
        marginBottom: '0.5rem',
        gap: '0.5rem',
        display: 'grid',
        textAlign: 'center',
        gridTemplateColumns: 'repeat(12, 1fr)',
        alignContent: 'center',
        alignItems: 'start'
    }]);

    return (
        <Stack
            className={props.styles ? props.styles : gridStyles}
        >
            {props.children}
        </Stack>
    )
}